<template>
  <span>
    <HoverPopNormal :isIcon="true" :top="true">
      <template #icon>
        <v-btn icon x-small>
          <slot>{{ $t(text) }}</slot>
          <v-icon
            :color="color"
            :small="small"
            :x-small="xSmall"
            :large="large"
            :x-large="xLarge"
            @click="click"
          >
            {{ 'mdi-help-circle' }}
          </v-icon>
        </v-btn>
      </template>
      <slot name="explanation" />
    </HoverPopNormal>
  </span>
</template>

<script>
import HoverPopNormal from '@/components/layouts/HoverPop/HoverPopNormal'
export default {
  name: 'HelpCircle',
  components: {
    HoverPopNormal
  },
  props: {
    size: {},
    color: { default: 'primary' },
    text: { default: '' }
  },
  data: function () {
    return {
      xSmall: false,
      small: false,
      large: false,
      xLarge: false
    }
  },
  methods: {
    click() {},
    setSize() {
      switch (this.size) {
        case 'small':
          this.small = true
          break
        case 'x_small':
          this.xSmall = true
          break
        case 'large':
          this.large = true
          break
        case 'x_large':
          this.xLarge = true
          break
      }
    }
  },
  created() {
    this.setSize()
  }
}
</script>
<style lang="scss" scoped>
.test {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
}
</style>
